// extracted by mini-css-extract-plugin
var _1 = "ProvisionSelectOption-module__badge--m33HG";
var _2 = "ProvisionSelectOption-module__option--W9Sdi";
export { _1 as "badge", _2 as "option" }
